import { Controller } from '@hotwired/stimulus';
import { replaceWithCKEditor } from 'manage/ckeditor';

export default class extends Controller {
  static values = {
    imageUploadUrl: String,
    fileUploadUrl: String,
  };

  connect() {
    this.editor = replaceWithCKEditor(this.element, {
      imageUploadUrl: this.imageUploadUrlValue,
      fileUploadUrl: this.fileUploadUrlValue,
    });
  }

  disconnect() {
    this.editor?.destroy();
  }
}
